import { render, staticRenderFns } from "./MessInterna.vue?vue&type=template&id=3911ed7d&scoped=true"
import script from "./MessInterna.vue?vue&type=script&lang=js"
export * from "./MessInterna.vue?vue&type=script&lang=js"
import style0 from "./MessInterna.vue?vue&type=style&index=0&id=3911ed7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3911ed7d",
  null
  
)

export default component.exports